module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAAVklEQVRYw+2UsQnAMAwEbw/Pr9HsyjsoTQikDOSLhDv1/yCJAxF5wqBYLIqRid/0OTtRUVd809T7BfNWMD9YEF9R/MjxNxVdpIt0kS4SXaSLdJHI3zkAn9WSNfuF/K8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn_overflow.png
// module id = aKYT
// module chunks = 1